// @ts-expect-error
import { gtag } from 'ga-gtag';

// @ts-ignore
const gtagEvent: Gtag.Gtag = (command, ...args) => {
  try {
    // @ts-ignore
    gtag(command, ...args);
  } catch {
    // eslint-disable-next-line no-console
    console.error('Gtag error: GTM_ID is not defined');
  }
};

export default gtagEvent;
